module.exports = __webpack_public_path__ + "img/row-charging-start.b00e1bd0.png";